import { AppContext } from "@lightspeed-invoicing/core-client/frontend/index"
import $ from "jquery"
import React, { Component } from "react"
import { defineMessages, FormattedMessage, injectIntl } from "react-intl"
import { connect } from "react-redux"
import EventBus from "../common/EventBus.js"
import { getPriceListName } from "../name-helpers/priceListNameHelper"
import { STATUS_BULKS_IN_PROGRESS } from "../state/bulk-operation/BulkOperationsStatus"
import { setBulkOperationsStatus } from "../state/bulk-operation/BulkOperationStatusActions"
import { BULK_OPERATION_MESSAGES, BULK_OPERATION_TYPE } from "../utils/automation/bulk"

const messages = defineMessages({
    invoices: {
        id: "common.email.modal.invoice",
        defaultMessage: "invoices"
    },
    orders: {
        id: "common.email.modal.orders",
        defaultMessage: "orders"
    },
    contacts: {
        id: "common.email.modal.contacts",
        defaultMessage: "contacts"
    },
    companies: {
        id: "common.email.modal.companies",
        defaultMessage: "companies"
    },
    documents: {
        id: "common.email.modal.documents",
        defaultMessage: "documents"
    },

    start_button: {
        id: "common.email.modal.start_bulk_operation_btn",
        defaultMessage: "Start"
    },
    "send-bulk-email_button": {
        id: "bulk.modal.operations.emails_send.button",
        defaultMessage: "Send"
    },
    "bulk-delete_button": {
        id: "bulk.modal.operations.deletes.button",
        defaultMessage: "Delete"
    }
})

const fileNameMap = {
    [BULK_OPERATION_TYPE.SEND_EMAIL]: "SendBulkEmailComponent.tsx",
    [BULK_OPERATION_TYPE.ORDER_STATUS_UPDATE]: "OrdersUpdateStatusComponent.tsx",
    [BULK_OPERATION_TYPE.DELETE]: "BulkDeleteComponent.tsx",
    [BULK_OPERATION_TYPE.PRINT_INVOICE]: "bulk-print-invoices/BulkPrintInvoicesComponent.tsx",
    [BULK_OPERATION_TYPE.EXPORT]: "BulkExport.tsx",
    [BULK_OPERATION_TYPE.EDIT_INVOICE_LOCATION]: "BulkEditLocation.tsx",
    [BULK_OPERATION_TYPE.EDIT_CREDIT_MEMO_LOCATION]: "BulkEditLocation.tsx"
}

const COMPANIES_OBJECT = "companies"

class BulkModal extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            isLoading: false,
            modalId: this.props.modalId || "bulk-modal",
            operationType: this.props.operationType || "",
            filters: this.props.filters || {},
            metadata: this.props.metadata || {},
            object: this.props.object || "documents",
            numberOfItemsSelected: this.props.numberOfItemsSelected || 0,
            isDisabled: false
        }
        this.closeModal = this.closeModal.bind(this)
        this.createBulkOperation = this.createBulkOperation.bind(this)
    }

    componentDidMount() {
        $("#" + this.state.modalId).modal("show")
    }

    closeModal(event) {
        event.preventDefault()
        $("#" + this.state.modalId).modal("hide")
        if (this.props.onClose) {
            this.props.onClose(event)
        }
    }

    createBulkOperation(event) {
        this.setState({
            isLoading: true
        })
        event.preventDefault()
        AppContext.getApiClient()
            .post("/bulk-operations", {
                operationType: this.state.operationType,
                totalItems: this.state.numberOfItemsSelected,
                filters: this.state.filters,
                metadata: this.state.metadata,
                count: this.props.selectedItemsCount
            })
            .then(op => {
                if (this.props.onCreate) {
                    this.props.onCreate(op)
                }
                if (op.error) {
                    this.setState({
                        isLoading: false
                    })
                    return
                }
                this.props.setBulkOperationsStatus(STATUS_BULKS_IN_PROGRESS)
                EventBus.dispatch(EventBus.TopicSendSuccessNotification, {
                    message: (
                        <FormattedMessage
                            id="bulk.modal.operations.operation_created_message"
                            defaultMessage="The bulk operation started successfully. A notification will be sent to {email}"
                            values={{
                                email: <strong>{AppContext.getUserLoggedIn().attributes.email}</strong>
                            }}
                        />
                    )
                })
                this.closeModal(event)
            })
    }

    renderForm() {
        try {
            const fileName = fileNameMap[this.state.operationType] || this.state.operationType + ".component.jsx"
            const Form = require("./operations/" + fileName)
            if (!Form) {
                return ""
            }
            return (
                <Form.default
                    object={this.props.object}
                    operationType={this.state.operationType}
                    onChange={metadata => {
                        this.setState({ metadata })
                    }}
                    onDisable={disabled => {
                        this.setState({
                            isDisabled: disabled
                        })
                    }}
                />
            )
        } catch (e) {
            return ""
        }
    }

    renderTitle() {
        switch (this.state.operationType) {
            case BULK_OPERATION_TYPE.CREATE_ACCOUNT_STATEMENT:
                return (
                    this.props.object != COMPANIES_OBJECT ?
                        <FormattedMessage
                            id="bulk.modal.operations.create_statement_title_contacts"
                            defaultMessage="Create account statements for contacts"
                        /> :
                        <FormattedMessage
                            id="bulk.modal.operations.create_statement_title_companies"
                            defaultMessage="Create account statements for companies"
                        />
                )
            case BULK_OPERATION_TYPE.CONTACT_UPDATE:
                return (
                    this.props.object !== COMPANIES_OBJECT ?
                        <FormattedMessage id="bulk.modal.operations.contacts_updates_title" defaultMessage="Bulk update contacts" /> :
                        <FormattedMessage id="bulk.modal.operations.companies_updates_title" defaultMessage="Bulk update companies" />
                )
            case BULK_OPERATION_TYPE.APPLY_INVOICE_PAYMENT:
                return (
                    <FormattedMessage
                        id="bulk.modal.operations.apply_invoices_payments_title"
                        defaultMessage="Apply payments on open invoices"
                    />
                )
            case BULK_OPERATION_TYPE.EDIT_INVOICE_LOCATION:
                return (
                    <FormattedMessage
                        id="bulk.modal.operations.edit_invoices_location_title"
                        defaultMessage="Edit invoices location"
                    />
                )
            case BULK_OPERATION_TYPE.EDIT_CREDIT_MEMO_LOCATION:
                return (
                    <FormattedMessage
                        id="bulk.modal.operations.edit_credit_memos_location_title"
                        defaultMessage="Edit credit memos location"
                    />
                )
            case BULK_OPERATION_TYPE.APPLY_PRICE_LIST_PAYMENT:
                return (
                    <FormattedMessage
                        id="bulk.modal.operations.apply_invoices_from_price_list_bulk_payment_title"
                        defaultMessage="Apply bulk {priceList} payment"
                        values={{
                            priceList: getPriceListName(this.props.intl)
                        }}
                    />
                )
            case BULK_OPERATION_TYPE.SEND_EMAIL:
                return (
                    <FormattedMessage
                        id="bulk.modal.operations.invoices_email_title"
                        defaultMessage="Send {num} {object} by email"
                        values={{
                            num: this.props.numberOfItemsSelected,
                            object: this.props.intl.formatMessage(messages[this.props.object])
                        }}
                    />
                )
            case BULK_OPERATION_TYPE.ORDER_STATUS_UPDATE:
                return (
                    <FormattedMessage
                        id="bulk.modal.operations.change_order_status"
                        defaultMessage="Change status for {numOrders} order(s)"
                        values={{
                            numOrders: this.props.numberOfItemsSelected
                        }}
                    />
                )
            case BULK_OPERATION_TYPE.DELETE:
                return (
                    <FormattedMessage
                        id="bulk.modal.operations.delete_title"
                        defaultMessage="Bulk delete {object}"
                        values={{
                            object: this.props.intl.formatMessage(
                                messages[this.props.object] ? messages[this.props.object] : messages["documents"]
                            )
                        }}
                    />
                )
            case BULK_OPERATION_TYPE.PRINT_INVOICE:
                return (
                    <FormattedMessage
                        id="bulk.modal.operations.print_invoices_title"
                        defaultMessage="Prepare all invoices to print"
                    />
                )
            case BULK_OPERATION_TYPE.EXPORT:
                return this.props.intl.formatMessage(BULK_OPERATION_MESSAGES[BULK_OPERATION_TYPE.EXPORT])
        }
    }

    isStartButtonDisabled() {
        const noLocationSelected = [BULK_OPERATION_TYPE.EDIT_INVOICE_LOCATION, BULK_OPERATION_TYPE.EDIT_CREDIT_MEMO_LOCATION].includes(this.state.operationType) &&
            (Object.keys(this.state.metadata).length == 0 || Object.values(this.state.metadata)[0] == "")
        return this.props.disabled || this.state.isDisabled || noLocationSelected
    }

    render() {
        return (
            <div
                className="modal fade"
                id={this.state.modalId}
                role="dialog"
                aria-labelledby="bulkModalTitle"
                data-backdrop="static"
                data-keyboard="false"
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title mb-0 pb-0 border-0" id="bulkModalTitle">
                                <div className={"h5"}> {this.renderTitle()}</div>
                            </div>
                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className={"col-12"}>
                                        {this.renderForm()}
                                        {this.props.children}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={this.closeModal}>
                                <FormattedMessage id="common.email.modal.close_btn" defaultMessage="Close" />
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={this.createBulkOperation}
                                disabled={this.isStartButtonDisabled()}
                            >
                                {messages[this.state.operationType + "_button"] ? (
                                    <FormattedMessage {...messages[this.state.operationType + "_button"]} />
                                ) : (
                                    <FormattedMessage {...messages["start_button"]} />
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapState = (state, props) => ({ ...props })
const mapDispatch = { setBulkOperationsStatus }
const connector = connect(mapState, mapDispatch)
export default connector(injectIntl(BulkModal))



// WEBPACK FOOTER //
// ./src/bulk/modal.component.jsx